module.exports = __webpack_public_path__ + "img/portfolio-sidebar.ded39861.svg";